import React from 'react';
import { usePermissionContext } from './permission-provider';

const useRepositoryPermissionContext = () => {
    const { hasPermission, runHandler } = usePermissionContext();

    const { canModify } = React.useMemo(() => {
        return {
            canModify: hasPermission('Repository Modify'),
        };
    }, [hasPermission]);

    return {
        hasPermission,
        canModify,
        runHandler,
    };
};
export { useRepositoryPermissionContext };
